module.exports = __webpack_public_path__ + "img/icon6.b62811d1.svg";